import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import type { RootState } from '../../app/app-store';

export interface FiUiState {
  fiInitialized: boolean;
  fiCleared: boolean;
}

const initialState: FiUiState = {
  fiInitialized: false,
  fiCleared: false,
};

const fiUiSlice = createSlice({
  name: 'fiUi',
  initialState,
  reducers: {
    setFiInitialized(state, action: PayloadAction<boolean>) {
      state.fiInitialized = action.payload;
    },
    setFiCleared(state, action: PayloadAction<boolean>) {
      state.fiCleared = action.payload;
    },
    resetFiUi() {
      return initialState;
    },
  },
});

export const { setFiInitialized, setFiCleared, resetFiUi } = fiUiSlice.actions;
export const fiUiReducer = fiUiSlice.reducer;

export const selectFiInitialized = (state: RootState) =>
  state.fiUi.fiInitialized;
export const selectFiCleared = (state: RootState) => state.fiUi.fiCleared;
